import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=83b0f750&scoped=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"
import style0 from "./Error.vue?vue&type=style&index=0&id=83b0f750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b0f750",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnForm: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-form.vue').default})
